import { getCsrfToken } from '../../utils/api_helper'

function initResourceList() {
  const links = document.querySelectorAll('a.hyper-resource-link')

  links.forEach((link) =>
    link.addEventListener('click', async () => {
      const linkId = (link as HTMLElement).dataset.id
      try {
        const csrfToken = getCsrfToken()
        await fetch(`/resources/resource-link-visit/${linkId}/`, {
          method: 'POST',
          headers: {
            'x-csrftoken': csrfToken,
          },
          body: '',
        })
      } catch (e) {
        console.error(e)
      }
    }),
  )
}

export { initResourceList }
